/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 分页查询评论
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetCommentPageParams {
  constructor(public page: number, public pageSize: number) {}
}

export default async function (
  id: string,

  params: GetCommentPageParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.CloudTheaterCommentDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/cloundtheater-comments/${id}`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
